import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Meta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(Meta,{
  refreshOnceOnNavigation: true
});

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {path: '/index.html', redirect:'/'},
  {path: '/index', redirect:'/'},
  {path: '/home', redirect:'/'},

  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('../views/Contacts.vue')
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: () => import('../views/Portfolio.vue')
  },{
    path: '/portfolio/celebration',
    name: 'Celebration',
    component: () => import('../views/portfolio/Celebration')
  },{
    path: '/portfolio/commercial',
    name: 'Commercial',
    component: () => import('../views/portfolio/Commercial')
  },{
    path: '/portfolio/nightevents',
    name: 'NightEvents',
    component: () => import('../views/portfolio/NightEvents')
  },{
    path: '/portfolio/portraits',
    name: 'Portraits',
    component: () => import('../views/portfolio/Portraits')
  },{
    path: '/portfolio/sport',
    name: 'Sport',
    component: () => import('../views/portfolio/Sport')
  },{
    path: '/instagram',
    name: 'Instagram',
    component: () => import('../views/Instagram')
  },{
    path: '/instagram/matteortili',
    name: 'IG MatteOrtili',
    component: () => import('../views/instagram/ig_personal')
  },{
    path: '/instagram/matteortiliart',
    name: 'IG MatteOrtiliArt',
    component: () => import('../views/instagram/ig_photo')
  },{
    path: '/works',
    name: 'Works',
    component: () => import('../views/Works')
  },{
    path: '/work',
    name: 'Work',
    component: () => import('../views/Work')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,

  //Se non è in history mode
  // scrollBehavior () {
  //   document.body.scrollTop = 0; // For Safari
  //   document.documentElement.scrollTop = 0;
  // }
});


export default router
